import { useQuery } from '@tanstack/react-query';
import { Foreground } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function useStudentForegrounds(studentId = null, season = null) {
  if (studentId) {
    return useQuery([QUERY_KEYS.foregrounds, studentId, season], () => (
      Foreground
        .where({ studentId: studentId })
        .where({ forSeason: season })
        .all()
        .then((res) => {
          return res.data;
        })
    ), { placeholderData: [] });
  } else {
    return [];
  }
}
